const IrisRoutes = {
    'ReviewSummary' : 'review/summary/',
}

export { IrisRoutes }